import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import {
  attendeeCameraStatus,
  attendeeNetworkHealth,
  attendeeReceivedFrame,
  attendeeMuteStatus,
  attendeeRoster,
  mediaPlayerSettings,
  meeting,
  videoInputDevice,
  audioInputDevice,
  audioOutputDevice,
  overlays,
  banners,
  modal,
  streamEndpoints as broadcastStreamEndpoints,
  backgrounds,
  eventMedia as broadcastEventMedia,
  screenShareCount,
  broadcast,
  directorRequests,
  settings as broadcastSettings,
  attendeeDetails,
  notification,
  user,
  isLoggedOut,
  startProgram,
  featuredPresenter,
  knocks,
  permissions,
  uploadStatusVisibility,
  uploadStatus,
  templates as broadcastTemplates,
  program,
  brandingSettings,
  sceneLayers,
  sourceUpdateStatus,
  liveSources,
  readinessCheck,
  showReadinessCheck,
  sandboxMeetingStatus,
  sandboxMeetingSession,
  sources as broadcastSources,
  attendeePresence,
  videoDeviceLost,
  userBackground,
  attendeeReadinessCheck,
  transformedVideoInputs,
  attendeeVoiceIntensity
} from '@shoflo/studio-redux/reducers';

import { presenterSettingsSource } from '@shoflo/studio-redux/reducers/presenters';

//User reducers
import loaders from './loader';
import features from './features';

//Event reducers
import { event } from '@shoflo/studio-redux/reducers/event';
import eventCrew from './eventCrew';

//Team reducers
import { team } from '@shoflo/studio-redux/reducers/team';

// import attendeeTiles from './attendeeTiles';
import attendeeMetrics from './attendeeMetrics';
import dismissedAttendees from './dismissedAttendees';

import sceneLayout from './sceneLayout';
import broadcastSourceDisconnectTimeouts from './broadcastSourceDisconnectTimeouts';
import attendeeTile from './attendeeTile';

//Sidebar
import sidebar from './sidebar';

//Show reducers
import broadcastScenes from './broadcastScenes';

import bannerTemplates from './bannerTemplates';

// SourcesTabs
import tabs from './tabs';

// Stage Sources
import stagedSources from './stagedSources';

// Templates
import templateTabs from './templatesTab';

// EditSourceOrder
import editSourceOrder from './EditSourceOrder/editSourceOrder';

// DragSource
import dragSource from './DragSource/dragSource';

// Music Profile
import attendeeContentShareAudioProfile from './attendeeContentShareAudioProfile';

// Recordings
import broadcastRecordings from './broadcastRecording';

import showStopStreamConfirmation from './showStopStreamConfirmation';

import featureFlags from './featureFlags';
import serverTimeDelta from './serverTimeDelta';

import scenesWithSource from './scenesWithSource';

import toggleNotificationList from './toggleNotificationList';

import broadcastSessionId from './broadcastSessionId';

import reloadBanner from './reloadBanner';

export default function reducer(history) {
  return combineReducers({
    router: connectRouter(history),
    loaders,
    modal,
    features,
    user,
    isLoggedOut,
    event,
    eventCrew,
    team,
    meeting,
    attendeePresence,
    attendeeRoster,
    attendeeMetrics,
    attendeeMuteStatus,
    dismissedAttendees,
    attendeeNetworkHealth,
    attendeeReceivedFrame,
    audioInputDevice,
    videoInputDevice,
    audioOutputDevice,
    program,
    sceneLayout,
    broadcastSources,
    broadcastSourceDisconnectTimeouts,
    broadcastStreamEndpoints,
    knocks,
    featuredPresenter,
    sidebar,
    broadcast,
    overlays,
    backgrounds,
    sceneLayers,
    mediaPlayerSettings,
    liveSources,
    bannerTemplates,
    banners,
    notification,
    uploadStatusVisibility,
    uploadStatus,
    tabs,
    attendeeCameraStatus,
    stagedSources,
    attendeeTile,
    broadcastSettings,
    broadcastTemplates,
    permissions,
    directorRequests,
    presenterSettingsSource,
    editSourceOrder,
    templateTabs,
    broadcastEventMedia,
    dragSource,
    attendeeContentShareAudioProfile,
    broadcastRecordings,
    showStopStreamConfirmation,
    broadcastScenes,
    startProgram,
    featureFlags,
    scenesWithSource,
    serverTimeDelta,
    toggleNotificationList,
    attendeeDetails,
    screenShareCount,
    broadcastSessionId,
    reloadBanner,
    sourceUpdateStatus,
    brandingSettings,
    readinessCheck,
    showReadinessCheck,
    sandboxMeetingStatus,
    sandboxMeetingSession,
    videoDeviceLost,
    userBackground,
    attendeeReadinessCheck,
    transformedVideoInputs,
    attendeeVoiceIntensity
  });
}
